import {defineMessages} from 'react-intl';

export default defineMessages({
	login: {
		id: 'auth.login.submit',
		defaultMessage: 'Login',
	},
});
